// External dependencies
import get from 'lodash.get';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ParentContent from './ParentContent'
import ParentReportBatchPrint from './ParentReportBatchPrint'

// Internal Dependencies
import { states } from '../../values/enums';

// Components
import Loading from '../../../Global/Loading';
import PageStatus from '../../../Teacher/PageStatus';
import Error from '../../../Teacher/Error';

class ParentContainer extends Component {
  constructor (props) {
    super(props);
    this.state = {
      firstName: "",
      componentError: null,
    };
  }

  componentDidMount () {
    this.props.initializeData();
  }

  componentDidUpdate(prevProps) {
    // I anticipate that you won't be thrilled with this, Kathleen
    if(this.props.selectedStudent && this.props.selectedStudent != "") {
      let firstName = this.props.selectedStudent.substr(0, this.props.selectedStudent.indexOf(" "));
      if(firstName != this.state.firstName) {
        this.setState({
          firstName,
        });
      }
    }

  }

  render () {
    let parentReport;
    let hasTakenAssessment;
    const { report, reportStatus, progressReport, progressReportStatus, batchPrint } = this.props;

    if(this.state.componentError) {
      return <Error customMessage={this.state.componentError} />;
    }

    if(report && progressReport && progressReport.data && progressReport.data.length > 0) {
      hasTakenAssessment = progressReport.data.filter(act => act.type === 'assessment');
    }

    if(reportStatus && reportStatus.type === states.COMPLETE && progressReport && progressReportStatus.type === states.COMPLETE) {
      if(report && progressReport && progressReport.data && !report.reportNotAvailable) {
        parentReport = <ParentContent name={this.props.selectedStudent} parentReport={report} progressReport={progressReport} />
      } else {
        let equated = false;
        if(this.props.selectedMetric && this.props.selectedMetric.value == 'ORF' && this.props.selectedEquating) {
          equated = true;
        }
        parentReport =
          <PageStatus
            isAggregateReport={false}
            viewText= "Parent Report"
            equated={equated}
          />;
      }
    } else if(reportStatus && progressReportStatus && (reportStatus.type === states.ERROR || progressReportStatus.type === states.ERROR)) {
      parentReport = <Error />;
    } else {
      parentReport = <Loading />;
    }

    return (
      <div className="reports-container parent">
        {batchPrint ? <ParentReportBatchPrint small={false} /> : parentReport}
      </div>
    );


  }
}

function mapStateToProps (state) {
  const { roster } = state.reports;
  return {
    selectedEquating: get(state, 'reports.teacher.equatingSelection', true),
    selectedStudent: roster.ui && roster.ui.selections.student ? roster.ui.selections.student.label : "",
    batchPrint: roster.batchPrint,
    report: get(state, 'reports.parent.report.data', null),
    reportStatus: get(state, 'reports.parent.report.status', null),
    progressReport: get(state, 'reports.progress.report.data', null),
    progressReportStatus: get(state, 'reports.progress.report.status', null),
    selectedBenchmark: get(state, 'reports.teacher.selections.benchmark', {}),
    selectedMetric: get(state, 'reports.teacher.selections.metric', {}),
    customBenchmarks: get(state, 'reports.teacher.customBenchmarks'),
    selectedLocale: get(state, 'reports.teacher.selectedLocale', null),
  };
}

// TODO parent prop types
ParentContainer.propTypes = {
  // describe
  teacher: PropTypes.object,
  // describe
  selections: PropTypes.object,
  // describe
  report: PropTypes.object,
  // container-level status
  status: PropTypes.string,
}

export default connect(mapStateToProps)(ParentContainer)
